<template>
	<div class="order-detail order-confirm" v-show="loaded">
		<div class="row">
			<div class="form-header">
				<p style="margin-left:15px;">如下信息将用于签订合同、开通服务，请确认是否正确.</p>
			</div>
		</div>
		<div class="section-title">订单编号 
			<span>{{ order.order_no }}</span> 
		</div>
		<div class="info-card">
			<div class="subtitle-info">套餐信息</div>
			<ul class="info-cont">
				<li><span class="label">套餐名称</span><span>{{ order.product_pkg_title }}</span></li>
				<li><span class="label">应付金额</span><span>{{ order.rel_pay_price }}元</span></li>
				<li><span class="label">服务时间</span><span>{{ order.service_period }} {{ order.granularity == 2 ? '天' : '个月' }}</span></li>
			</ul>
			<div class="subtitle-info top-dashed-line">购买人信息</div>
			<ul class="info-cont">
				<li>
					<span class="label">姓名</span>
					<input class="text-left" readonly v-model="order.customer_name">
				</li>
				<li>
					<span class="label">手机号码<span class="red">*</span></span>
					<input class="text-left" readonly v-model="order.customer_mobile">
				</li>
				<li v-if="confiming" class="warning">请确认手机号码，以顺利进行问卷和签订合同</li>
			</ul>
		</div>
		<div class="section-title" style="margin-top: 6px" @click="couponListVisibel=true">
			<div class="subtitle-info" >优惠券  
				<span v-if="couponIndex==null" class="no-coupon">{{couponMsg}}</span>
				<span v-else class="amount">- ¥{{discount}}</span>
				<b> ></b>
			</div>
		</div>
		<div class="actions">
			<mt-button type="primary" @click="checkCoupon" v-text="btnText"></mt-button>
			<p class="mt-50">温馨提示: 如有疑问请联系您的专属服务助理</p>
		</div>
		<div class="coupon-shadow" v-show="couponListVisibel">
			<div class="coupon-box">
				<div class="coupon-title">优惠券选择 <span class="coupon-close" @click="couponListVisibel=false"><img src="/static/img/iconClose.png" alt=""></span></div>
				<div class="coupon-list" v-if="couponList.length">
					<div class="coupon-card" v-for="(coupon, i) in couponList" :key="coupon.code">
						<div class="ticket">
							<!-- 现金抵扣 -->
							<div class="money-off" v-show="coupon.type == 10">
								<img src="/static/img/Coupon_Discount_Left.png" alt="">
								<div class="money" v-if="coupon.amount <= 10000">{{coupon.amount}}<span>元</span></div>
								<div class="money" v-else-if="coupon.amount > 10000">{{coupon.amount/10000}}<span>万</span></div>
							</div>
							<!-- 满减 -->
							<div class="money-off" v-show="coupon.type == 20">
								<img  src="/static/img/Coupon_Full_Left.png" alt="">
								<div class="full-money">
									<div class="full-title">满减券</div>
									<div class="full-des">每满{{coupon.type_value}}减{{coupon.amount}}</div>
								</div>
							</div>
							<div class="ticket-content">
								<div class="ticket-title">{{coupon.title}}</div>
								<div class="ticket-date">{{formatData(coupon.start_time)}}-{{formatData(coupon.end_time)}}</div>
								<img class="ticket-expired" v-if="coupon.expire_status === 15" src="/static/img/Subscript_FastExpired.png" alt="">
								<div class="ticket-radio" @click="selectCoupon(i)">
									<img v-if="couponIndex == i" src="/static/img/Select.png" alt="">
									<img v-else src="/static/img/Editing_Reveal.png" alt="">
								</div>
							</div>
						</div>
						<div class="description">{{coupon.range_description}}</div>
					</div>
				</div>
				<div class="no-coupon" v-else>
					<img src="/static/img/Coupon.png" alt="">
					<div class="tip">暂无可用优惠券，去别处逛逛吧</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Button, MessageBox } from 'mint-ui'

export default {
	name: 'OrderConfirm',
	data: () => ({
		'order': {},
		'customer': {},
		'loaded': false,
		'btnText': '确认',
		'confiming': true,
		'new_customer': true,
		'couponListVisibel': false,
		'couponList': [],
		'discount': '',
		'couponIndex': null,
		'couponCode': '',
		'couponMsg': '暂无优惠券信息'
	}),
	computed: {
	},
	created () {
	},
	components: {
		'mt-button': Button
	},
	mounted: function () {
		this.setPageTitle('订单确认')
		this.fetchDetail()
		this.getH5CouponList()
		if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
			this.handleFontSize()
		} else {
			if (document.addEventListener) {
				document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false)
			} else if (document.attachEvent) {
				document.attachEvent('WeixinJSBridgeReady', this.handleFontSize)
				document.attachEvent('onWeixinJSBridgeReady', this.handleFontSize)
			}
		}
	},
	methods: {
		fetchDetail () {
			this.loading('正在读取订单信息...')
			this.getOrderFullDetail(this.$route.params.id, 'confirm', rs => {
				if (rs.data.to) {
					this.$router.replace('/my/orders')
				} else {
					this.order = rs.data.order
					this.order.rel_pay_price = this.order.pay_price
					this.new_customer = rs.data.new_customer
					this.confiming = rs.data.new_customer && this.order.is_confirming
					this.customer = rs.data.customer
					this.$store.dispatch('setOrder', {'order': this.order})
					if (this.order.is_confirming === true) {
						this.btnText = '确认'
					} else {
						this.btnText = '您已确认，下一步'
					}
					this.loaded = true
				}
			})
		},
		getH5CouponList () {
			this.getCouponList(this.$route.params.id, rs => {
				if (rs.code === 0) {
					this.couponList = rs.data
					this.couponList.forEach(d => {
						if (d.type === 20) {
							let payPrice = Number(this.order.pay_price)
							let typeValue = Number(d.type_value)
							d.rel_amount = parseInt(payPrice / typeValue) * d.amount
						} else {
							d.rel_amount = d.amount
						}
					})
					if (this.couponList.length > 0) {
						this.couponMsg = "未选择"
					} else {
						this.couponMsg = "暂无优惠券信息"
					}
				} else {
					this.couponList = []
				}
			})
		},
		selectCoupon (index) {
			if (this.couponIndex === index) {
				this.couponIndex = null
				this.couponCode = ''
				this.discount = ''
				this.order.rel_pay_price = this.order.pay_price
			} else {
				this.couponIndex = index
				this.couponCode = this.couponList[index].code
				this.discount = this.couponList[index].rel_amount
				this.order.rel_pay_price = (this.order.pay_price - this.discount) + '.00'
			}
		},
		formatData (val) {
			var currentdate = val.replace(/-/g, '.')
			currentdate = currentdate.substring(0, 10)
			return currentdate;
		},
		// 确认是否有可用优惠券，有则做出响应提示
		checkCoupon () {
			if (this.couponList.length > 0 && !this.discount) {
				MessageBox({
					title: '温馨提示',
					message: '您还有尚未使用的优惠券，是否要返回进行使用？',
					showCancelButton: true,
					confirmButtonText: '去使用',
					cancelButtonText: '不使用'
				}).then(action => {
					if (action === 'confirm') {
						console.log('去使用优惠券')
					} else {
						this.onSubmitClick()
					}
				})
			} else {
				this.onSubmitClick()
			}
		},
		onSubmitClick () {
			// this.toast('确认订单信息无误')
			if (this.new_customer && this.order.is_confirming === false) {
				if (this.order.pay_kind === 20) {
					window.location.href = '?#/pay/split/' + this.order.order_no
				} else {
					window.location.href = '?#/pay/ways/' + this.order.order_no
				}
				return
			}
			MessageBox.confirm('<div style="text-align: left; line-height: 1.5;">以下信息将用于签订合同、开通服务，您确定该订单信息正确吗？</div>' +
				'<div class="messageBox_info" style="background: #f8f8f8; line-height: 30px; font-size: 15px; color: #333; text-align: left; padding: 10px 15px; border-radius: 6px; margin-top: 8px;">' +
				'<div>姓名： <span style="color: #ff8a05;">' + this.order.customer_name + '</span></div>' +
				'<div>手机号码： <span style="color: #ff8a05;">' + this.order.customer_mobile + '</span></div>' +
				'<div>套餐名称： ' + this.order.product_pkg_title + '</div>' +
				'<div>应付金额： ' + this.order.rel_pay_price + '</div>' +
				'</div>').then(action => {
				if (action === 'confirm') {
					this.doConfirm()
				}
			}, action => {
			})
		},
		doConfirm () {
			let url = '/api/orders/customers/' + this.order.customer_id
			let params = {'mobile': this.order.customer_mobile, 'wx_id': this.customer.wx_id, 'order_no': this.$route.params.id, 'coupon_code': this.couponCode}
			this.loading('正在保存...')
			this.$http.put(url, params).then(response => {
				this.loadingHide()
				console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					window.location.href = '?#/pay/ways/' + this.order.order_no
				} else {
					this.handleHttpError(response, true)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		onInputFocus (tagId) {
			this.$refs[tagId].focus()
		},
		handleFontSize () {
			// 设置网页字体为默认大小
			window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 })
			// 重写设置网页字体大小的事件
			window.WeixinJSBridge.on('menu:setfont', function () {
				window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 })
			})
		}
	}
}
</script>

<style scoped>
	body { /* IOS禁止微信调整字体大小 */
		-webkit-text-size-adjust: 100% !important;
		text-size-adjust: 100% !important;
		-moz-text-size-adjust: 100% !important;
	}
	.subtitle-info b{
		font-weight: normal;
		color: #999;
	}
	.subtitle-info span.amount{
		margin-left: 35px; 
		color: #449AFF; 
		font-weight: normal
	}
	.subtitle-info span.no-coupon{
		margin-left: 35px; 
		color: #999; 
		font-weight: normal
	}
	.coupon-shadow{
		background: rgba(0,0,0,.3);
		position: fixed;
		overflow: hidden;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1050;
	}
	.coupon-box{
		margin-top: 94px;
		width: 100%;
		height: calc(100% - 94px);
		position: relative;
		background: #fff;
	}
	.coupon-title{
		border-bottom: 1px solid #e2e2e2;
		height: 45px;
		line-height: 45px;
		font-size: 14px;
		color: #666;
		padding: 0 15px;
	}
	.coupon-close{
		display: block;
		float: right;
		height: 45px;
		line-height: 45px;
		padding-left: 15px;
	}
	.coupon-close img{
		width: 16px;
	}
	.no-coupon{
		text-align: center;
	}
	.no-coupon img {
		margin-top: 130px;
		width: 120px;
	}
	.no-coupon .tip{
		margin-top: 12px;
		color: #999;
		font-size: 13px;
		line-height: 18px;
	}
	.coupon-list{
		padding: 15px;
		overflow: auto;
    	height: calc(100% - 45px);
	}
	.coupon-card{
		box-shadow: 0 0 6px rgba(0, 0, 0 ,.1);
	}
	.coupon-card .ticket{
		height: 94px;
		position: relative;
	}
	.coupon-card .money-off{
		position: relative;
		float: left;
		width: 132px;
	}
	.coupon-card .money-off img{
		position: absolute;
		left: -8px;
		top: -6px;
		width: 138px;
		height: 106px;
	}
	.money-off .money{
		position: absolute;
		top: 22px;
		left: 0;
		width: 100%;
		text-align: center;
		font-size: 36px;
		line-height: 50px;
		font-weight: bold;
		color: #fff;
	}
	.money-off .money span{
		font-size: 14px;
		font-weight: normal;
	}
	.money-off .full-money{
		position: absolute;
		top: 14px;
		left: 0;
		width: 100%;
		text-align: center;
		color: #fff;
	}
	.money-off .full-title{
		font-size: 30px;
		line-height: 42px;
		font-weight: bold;
	}
	.money-off .full-des{
		margin-top: 3px;
		font-size: 14px;
		line-height: 20px;
	}
	.ticket-content{
		position: relative;
	}
	.ticket-radio{
		position: absolute;
		right: 15px;
		top: 38px;
		width: 18px;
		height: 18px;
	}
	.ticket-radio img{
		width: 100%;
	}
	.coupon-card .description{
		padding: 10px 12px;
		background: #F8F8F8;
		font-size: 12px;
		color: #666;
		line-height: 17px;
		margin-bottom: 16px;
	}
	.ticket-title{
		height: 56px;
		padding: 12px 43px 0 142px;
		font-size: 16px;
		line-height: 22px;
		color: #333;
	}
	.ticket-date{
		padding: 8px 0 0 142px;
		color: #999;
		font-size: 13px;
		line-height: 18px; 
	}
	.ticket-expired{
		position: absolute;
		right: 0;
		top: 0;
		width: 58px;
		height: 44px; 
	}
</style>



// WEBPACK FOOTER //
// src/views/customer/OrderConfirm.vue